agents<template lang="html">
  <article class="">
    <h3 style="text-align: center">Nuevo agente</h3>
    <v-container fluid>
      <v-layout row wrap>
        <v-flex xs>
          <form @submit="checkForm" method="post">
            <section>
              <!-- Nombre -->
              <v-text-field
                name="name"
                label="Nombre"
                type="text"
                required
                v-model="agent.user_info_attributes.name"></v-text-field>
              <!-- Apellido -->
              <v-text-field
                name="last_name"
                label="Apellido"
                type="text"
                required
                v-model="agent.user_info_attributes.last_name"></v-text-field>


              <v-text-field
                name="mobile"
                label="Teléfono"
                type="number"
                required
                v-model="agent.attributes.mobile"
                ></v-text-field>

              <v-flex xs12>
                <label>Correo</label>
                <v-text-field
                  prepend-icon="person"
                  name="email"
                  label="Correo"
                  persistent-hint
                  readonly
                  return-object
                  single-line
                  type="email"
                  v-model="agent.attributes.email"></v-text-field>
                </v-flex>

                <v-flex xs12>
                  <label>Contraseña</label>
                  <v-text-field
                    id="password"
                    prepend-icon="lock"
                    name="password"
                    label="Contraseña"
                    persistent-hint
                    return-object
                    single-line
                    type="password"
                    v-model="agent.attributes.password"></v-text-field>
                </v-flex>

                <v-flex xs12>
                  <label>Confirmar contraseña</label>
                  <v-text-field
                    id="password_confirmation"
                    prepend-icon="lock"
                    name="password_confirmation"
                    label="Confirmar contraseña"
                    persistent-hint
                    return-object
                    single-line
                    type="password"
                    v-model="agent.attributes.password_confirmation"></v-text-field>
                </v-flex>


                <!-- <v-flex xs12>
                  <label>Contraseña</label>
                  <v-text-field
                    id="password"
                    prepend-icon="lock"
                    name="password"
                    label="Contraseña"
                    persistent-hint
                    return-object
                    required
                    single-line
                    type="password"
                    v-model="agent.attributes.password"></v-text-field>
                </v-flex>

                <v-flex xs12>
                  <label>Confirmar contraseña</label>
                  <v-text-field
                    id="password_confirmation"
                    prepend-icon="lock"
                    name="password_confirmation"
                    label="Confirmar contraseña"
                    persistent-hint
                    return-object
                    required
                    single-line
                    type="password"
                    v-model="agent.attributes.password_confirmation"></v-text-field>
                </v-flex> -->

              <v-btn
                color="blue"
                type="submit">Actualizar</v-btn>


            </section>
          </form>

        </v-flex>

      </v-layout>
    </v-container>
  </article>
</template>

<script>
export default {
  data(){
    return{
      genders:["m","f"],
      id:'',
      is_valid: false,
      location_selected:'',
      locations:[],
      agent:{
        user_info_attributes:{
          name: '',
          last_name: '',
          gender: '',
          location_id: '',
        },
        attributes:{
          email: '',
          password: '',
          password_confirmation: '',
          user_info_type: 'Agent',
          mobile: ''
        }
      }
    }
  },
  mounted(){
    const data={company:{id:this.getCompany().id}}
    try {
      this.$http.post('locations/company',{data:this.encrypt(data).toString()},{
            headers:{
            "X-Device-ID": this.getDeviceId(),
            "Authorization": 'Bearer ' + this.getUserToken()
            }
        })
      .then(function(response){
        this.locations= response.body.data
      }, function(response){
        if(typeof response.body.errors[0].details != "object"){
          alert(response.body.errors[0].details);
        }else{
          let message = []
          for(var key in response.body.errors[0].details){
            message.push(response.body.errors[0].details[key])
          }
          alert(message);
        }
      })
    } catch (e) {
      alert(e.message)
    }
    var path = this.$route.path.split('/')
    try {
      this.$http.get('agents/'+ path[2],{
        headers: {
          "X-Device-ID" : this.getDeviceId(),
           "Authorization" : 'Bearer ' + this.getUserToken()
        }
      })
      .then(function(response){
        console.info(response)
        this.id=response.body.data.id;
        this.agent.user_info_attributes = response.body.included[0].attributes
        this.agent.attributes=response.body.data.attributes
        console.info(this.agent)
        console.info(this.getLocations())
        this.location_selected=this.getLocations()[this.agent.location_id]
        this.charged = true
      }, function(response){
        if(response.body.meta != undefined && response.body.meta != null){
          if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
            this.checkToken(response.body.meta.authentication_token)
          }
        }
        if(typeof response.body.errors[0].details != "object"){
          alert(response.body.errors[0].details);
        }else{
          let message = []
          for(var key in response.body.errors[0].details){
            message.push(response.body.errors[0].details[key])
          }
          alert(message);
        }
      })
    } catch (e) {
      alert(e.message)
    }
  },
  methods:{
    checkForm: function(e) {
      e.preventDefault()
      // cl agent.attributes.password
      // cl agent.attributes.password_confirmation
      if(this.agent.attributes.password != undefined && this.agent.attributes.password!=this.agent.attributes.password_confirmation){
        alert('Las contraseñas deben coincidir')
      }else if (this.agent.attributes.password != undefined && this.agent.attributes.password.length<4 && this.agent.attributes.password.length>0) {
        alert('La contraseña debe ser mayor a 4 caracteres')
      }else{
        var path = this.$route.path.split('/')
        try {
          // this.agent.user_info_attributes.location_id=this.location_selected.id
          this.$http.put('agents/'+ path[2],{
            data: this.encrypt(this.agent).toString()
          },{
            headers: {
              "X-Device-ID" : this.getDeviceId(),
               "Authorization" : 'Bearer ' + this.getUserToken()
            }
          }).then(function(response){
            this.$router.push({name: 'agent'})
            if(response.body.meta != undefined && response.body.meta != null){
              if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
          }, function(response){
            if(response.body.meta != undefined && response.body.meta != null){
              if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
          })
        } catch (e) {
          alert(e.message)
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/agents/Edit_agent.vue